import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentImageWrapper = styled.div`
  width: 56px;
  height: 56px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R8};
  position: relative;
  overflow: hidden;
`

export const AttachmentImagePreviewIcon = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${Color.White};
`

interface AttachmentCardWrapperProps {
  readOnly?: boolean
}

export const AttachmentCardWrapper = styled.div<AttachmentCardWrapperProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S8};
  padding-right: ${({ readOnly }) => (readOnly ? Spacing.S8 : Spacing.S40)};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  position: relative;
  cursor: pointer;

  &:hover ${AttachmentImageWrapper} {
    > section {
      filter: blur(2px) brightness(0.95);
    }

    ${AttachmentImagePreviewIcon} {
      display: flex;
    }
  }
`

/* Hack for truncating text within flex container */
export const AttachmentCardContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S4};
  min-width: 0;
`

export const RemoveButton = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
`

export const DropdownButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > button {
    max-width: min-content;
  }
`
